import styles from "./Header.module.css";
import HeaderMenu from "./HeaderMenu";

export default function Header() {
  return (
    <div className={styles.headerContainer}>
      <div
        onClick={() => (window.location.pathname = "/")}
        className={styles.logoContainer}
      >
        ॐ Pujari
      </div>
      <HeaderMenu />
    </div>
  );
}
